module.exports = __webpack_public_path__ + "static/media/podium.0bfe9589.svg";